import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CaseRequestDto } from '../models/dto/case-overview/case-request-dto.model';

@Injectable()
export class CaseRequestsService {
  constructor(private readonly httpClient: HttpClient) {}

  public getCaseRequests(caseId: string): Observable<Array<CaseRequestDto>> {
    const params = new HttpParams().set('caseNumber', caseId);

    return this.httpClient.get<Array<CaseRequestDto>>('/ApplicationCase/GetCaseRequests', { params });
  }
}
